type GalleryContent = {
    imageUrl: string
    quote: string
    logo: string
    author: string
    organization?: string
}

export const GalleryContent: GalleryContent[] = [
    {
        imageUrl: "/images/auth-gallery/calfire.webp",
        quote: "“We just turned a 5-day fire into a 2-day fire cause the dudes on the engines had accurate hot spot maps to seek and destroy with.”",
        logo: "/images/auth-gallery/calfire-logo2x.png",
        author: "Josh Silveira",
        organization: "Cal Fire",
    },
    {
        imageUrl: "/images/auth-gallery/forestry.webp",
        quote: "“Dryden Forest Management wanted a reliable orthomosaic and mapping tool with no hidden costs, Nova delivered.”",
        logo: "/images/auth-gallery/forestry-logo.png",
        author: "Dryden Forest Management",
        organization: undefined,
    },
    {
        imageUrl: "/images/auth-gallery/lafd.webp",
        quote: "“Nova is used agency wide by LAFD, from small structure fires to wide-scale incidents. Nova allows us to deliver valuable intelligence to ground teams like never before.”",
        logo: "/images/auth-gallery/lafd-logo2x.png",
        author: "Steve Hamilton",
        organization: "LAFD",
    },
    {
        imageUrl: "/images/auth-gallery/hbird.webp",
        quote: "“Nova makes it easy to process and deliver actionable orthomosaics to our clients. It's a must for our organization.”",
        logo: "/images/auth-gallery/hbird-logo2x.png",
        author: "Nico Torchia",
        organization: "HUMMINGBIRD DRONES",
    },
]
